import { render, staticRenderFns } from "./mint.pug?vue&type=template&id=54f0a540&scoped=true&lang=pug&external"
import script from "./mint.js?vue&type=script&lang=js&external"
export * from "./mint.js?vue&type=script&lang=js&external"
import style0 from "./mint.scss?vue&type=style&index=0&id=54f0a540&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f0a540",
  null
  
)

export default component.exports